import theme from '../../base';

const collapse = {
  bg: theme.colors.neutrals.gray850,
  border: theme.colors.neutrals.gray800,
  foreground: theme.colors.neutrals.gray200,
  header: {
    bg: theme.colors.neutrals.gray800,
    foreground: theme.colors.neutrals.gray500,
    icon: theme.colors.neutrals.white,
  },
};

export default collapse;
